/* ----------------------------------------------------------------------------
   BLOCS DU TIROIR PANIER

   Gestion des interactions personnalisees du drawer : protection de livraison,
   selecteur de quantite compact et zoom image des recommandations.
   -------------------------------------------------------------------------- */

(function () {
  if (window.__cartDrawerBlocksBound) return;
  window.__cartDrawerBlocksBound = true;

  var dernierBoutonZoom = null;
  var fileAjoutsWoopie = Promise.resolve();

  function racine() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function sectionsABundler() {
    var sections = [];

    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));

    return sections;
  }

  function previent(panier) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: panier }
    }));
  }

  /* ------------------------------------------------------------------------
     AJOUTS WOOPIE DEPUIS LES RECOMMANDATIONS DU CART

     Ces boutons mettent à jour le panier existant avec cart/update.js.
     Ils n'utilisent pas le parcours d'ajout principal cart/add.js.
     ------------------------------------------------------------------------ */

  async function executerAjoutWoopie(variante) {
    var sections = sectionsABundler();

    var lecture = await fetch(racine() + 'cart.js', {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    var panierAvant = await lecture.json();

    if (!lecture.ok) {
      throw new Error(panierAvant.description || 'cart');
    }

    var ligneExistante = Array.isArray(panierAvant.items)
      ? panierAvant.items.find(function (item) {
          return Number(item.variant_id) === Number(variante);
        })
      : null;

    var cible = ligneExistante ? ligneExistante.key : String(variante);
    var quantite = ligneExistante
      ? (Number(ligneExistante.quantity) || 0) + 1
      : 1;
    var updates = {};

    updates[cible] = quantite;

    var miseAJour = await fetch(racine() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        updates: updates,
        sections: sections
      })
    });

    var panierFinal = await miseAJour.json();

    if (!miseAJour.ok) {
      throw new Error(panierFinal.description || 'update');
    }

    previent(panierFinal);

    if (!panierFinal.sections) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
  }

  function ajouterWoopieDepuisReco(formulaire) {
    var champVariante = formulaire.querySelector('input[name="id"]');
    var bouton = formulaire.querySelector('.woopie-cart-reco__add');
    var variante = champVariante ? parseInt(champVariante.value, 10) : 0;

    if (!variante) return;
    if (bouton && bouton.hasAttribute('aria-busy')) return;

    if (bouton) {
      bouton.setAttribute('aria-busy', 'true');
      bouton.disabled = true;
    }

    /*
     * Chaque clic est mis en file. Même si la cliente tape très vite sur
     * deux boutons AJOUTER, le 2e ajout attend que le 1er soit entièrement
     * recalculé et rendu avant de partir.
     */
    fileAjoutsWoopie = fileAjoutsWoopie
      .catch(function () {
        /* Une erreur précédente ne doit pas bloquer les prochains ajouts. */
      })
      .then(function () {
        return executerAjoutWoopie(variante);
      })
      .catch(function (erreur) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
          bubbles: true,
          detail: {
            error: String(erreur && erreur.message ? erreur.message : erreur)
          }
        }));
      })
      .finally(function () {
        if (bouton && document.documentElement.contains(bouton)) {
          bouton.removeAttribute('aria-busy');
          bouton.disabled = false;
        }
      });
  }

  function obtenirLightbox() {
    var existante = document.querySelector('[data-woopie-lightbox]');
    if (existante) return existante;

    var lightbox = document.createElement('div');
    lightbox.className = 'woopie-cart-image-lightbox';
    lightbox.setAttribute('data-woopie-lightbox', '');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML =
      '<div class="woopie-cart-image-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Anteprima dell’immagine del prodotto">' +
        '<button type="button" class="woopie-cart-image-lightbox__close" data-woopie-lightbox-close aria-label="Chiudi">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>' +
        '</button>' +
        '<img class="woopie-cart-image-lightbox__image" alt="">' +
      '</div>';

    var hote = document.getElementById('cart-drawer') || document.body;
    hote.appendChild(lightbox);
    return lightbox;
  }

  function ouvrirImage(bouton) {
    var source = bouton.getAttribute('data-image-src');
    if (!source) return;

    dernierBoutonZoom = bouton;

    var lightbox = obtenirLightbox();
    var image = lightbox.querySelector('.woopie-cart-image-lightbox__image');
    var fermeture = lightbox.querySelector('[data-woopie-lightbox-close]');

    if (!image) return;

    image.src = source;
    image.alt = bouton.getAttribute('data-image-alt') || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');

    if (fermeture) {
      window.setTimeout(function () {
        fermeture.focus();
      }, 0);
    }
  }

  function fermerImage() {
    var lightbox = document.querySelector('[data-woopie-lightbox]');
    if (!lightbox || !lightbox.classList.contains('is-open')) return;

    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');

    var image = lightbox.querySelector('.woopie-cart-image-lightbox__image');
    if (image) {
      window.setTimeout(function () {
        image.removeAttribute('src');
      }, 120);
    }

    if (dernierBoutonZoom && document.documentElement.contains(dernierBoutonZoom)) {
      dernierBoutonZoom.focus();
    }

    dernierBoutonZoom = null;
  }

  async function changerQuantite(bouton, direction) {
    var stepper = bouton.closest('[data-cd-quantity-stepper]');
    if (!stepper || stepper.hasAttribute('aria-busy')) return;

    var input = stepper.querySelector('input[data-line-key]');
    if (!input) return;

    var actuel = Number(input.value) || 1;
    var pas = Number(input.getAttribute('step')) || 1;
    var minimum = Number(input.getAttribute('min'));
    var maxAttr = input.getAttribute('max');
    var maximum = maxAttr !== null ? Number(maxAttr) : Infinity;

    if (!Number.isFinite(minimum)) minimum = 1;
    if (!Number.isFinite(maximum)) maximum = Infinity;

    var suivant = actuel + (direction * pas);
    suivant = Math.max(minimum, Math.min(maximum, suivant));

    if (suivant === actuel) return;

    var cleLigne = input.getAttribute('data-line-key');
    var sections = sectionsABundler();

    stepper.setAttribute('aria-busy', 'true');
    input.value = suivant;

    try {
      var reponse = await fetch(racine() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: cleLigne,
          quantity: suivant,
          sections: sections
        })
      });

      var panier = await reponse.json();

      if (!reponse.ok) {
        throw new Error(panier.description || 'change');
      }

      previent(panier);
    } catch (erreur) {
      input.value = actuel;
      document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: { error: String(erreur && erreur.message ? erreur.message : erreur) }
      }));
    } finally {
      stepper.removeAttribute('aria-busy');
    }
  }

  async function basculer(bouton) {
    if (bouton.hasAttribute('aria-busy')) return;

    var actif = bouton.getAttribute('aria-checked') === 'true';
    var cleLigne = bouton.getAttribute('data-line-key');
    var variante = bouton.getAttribute('data-variant-id');
    var sections = sectionsABundler();

    bouton.setAttribute('aria-busy', 'true');
    bouton.setAttribute('aria-checked', actif ? 'false' : 'true');

    try {
      if (actif && cleLigne) {
        var reponse = await fetch(racine() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: cleLigne, quantity: 0, sections: sections })
        });

        if (!reponse.ok) throw new Error('change');

        previent(await reponse.json());
      } else {
        var ajout = await fetch(racine() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [{ id: Number(variante), quantity: 1 }],
            sections: sections
          })
        });
        var resultat = await ajout.json();

        if (!ajout.ok) throw new Error(resultat.description || 'add');

        var panier = await (await fetch(racine() + 'cart.js')).json();

        panier.sections = resultat.sections;
        previent(panier);
      }
    } catch (erreur) {
      bouton.setAttribute('aria-checked', actif ? 'true' : 'false');
      document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: { error: String(erreur && erreur.message ? erreur.message : erreur) }
      }));
    } finally {
      bouton.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', function (event) {
    var formulaire = event.target && event.target.closest
      ? event.target.closest('.woopie-cart-reco__form')
      : null;

    if (!formulaire) return;

    /*
     * Capture avant le <form is="product-form"> natif d'Impact afin qu'une
     * seule logique AJAX pilote ces boutons de recommandation.
     */
    event.preventDefault();
    event.stopImmediatePropagation();
    ajouterWoopieDepuisReco(formulaire);
  }, true);

  document.addEventListener('click', function (event) {
    var zoom = event.target.closest('[data-woopie-image-zoom]');
    if (zoom) {
      event.preventDefault();
      event.stopPropagation();
      ouvrirImage(zoom);
      return;
    }

    var fermer = event.target.closest('[data-woopie-lightbox-close]');
    if (fermer) {
      event.preventDefault();
      fermerImage();
      return;
    }

    if (event.target.matches('[data-woopie-lightbox]')) {
      event.preventDefault();
      fermerImage();
      return;
    }

    var moins = event.target.closest('[data-cd-quantity-minus]');
    if (moins) {
      event.preventDefault();
      changerQuantite(moins, -1);
      return;
    }

    var plus = event.target.closest('[data-cd-quantity-plus]');
    if (plus) {
      event.preventDefault();
      changerQuantite(plus, 1);
      return;
    }

    var bouton = event.target.closest('[data-cd-protect]');
    if (!bouton) return;

    event.preventDefault();
    basculer(bouton);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      fermerImage();
    }
  });
})();
